// extracted by mini-css-extract-plugin
export default {"detailForm":"DetailForm_detailForm__a2eRW","media":"DetailForm_media__eWKpA"};